import { SHOW_SUCCESS_SNACKBAR, SHOW_DANGER_SNACKBAR, SHOW_DEFAULT_SNACKBAR, SHOW_WARNING_SNACKBAR, HIDE_SUCCESS_SNACKBAR, HIDE_DEFAULT_SNACKBAR, HIDE_WARNING_SNACKBAR, HIDE_DANGER_SNACKBAR } from "../actions/actionTypes";

const initialState = {
    show: {
        success: false,
        warning: false,
        danger: false,
        default: false
    },
    message: {
        success: '',
        warning: '',
        danger: '',
        default: ''
    }
};

export const snackbarsReducer = (state = initialState, action) => {
    switch (action.type) {
        case SHOW_SUCCESS_SNACKBAR:
            return {
                ...state,
                show: {
                    ...state.show,
                    success: true
                },
                message: {
                    ...state.show,
                    success: action.message
                },
            };
        case SHOW_DANGER_SNACKBAR:
            return {
                ...state,
                show: {
                    ...state.show,
                    danger: true
                },
                message: {
                    ...state.show,
                    danger: action.message
                },
            };
        case SHOW_DEFAULT_SNACKBAR:
            return {
                ...state,
                show: {
                    ...state.show,
                    default: true
                },
                message: {
                    ...state.show,
                    default: action.message
                },
            };
        case SHOW_WARNING_SNACKBAR:
            return {
                ...state,
                show: {
                    ...state.show,
                    warning: true
                },
                message: {
                    ...state.show,
                    warning: action.message
                },
            };

        case HIDE_SUCCESS_SNACKBAR:
            return {
                ...state,
                show: {
                    ...state.show,
                    success: false
                },
                message: {
                    ...state.show,
                    success: ''
                },
            };
        case HIDE_DANGER_SNACKBAR:
            return {
                ...state,
                show: {
                    ...state.show,
                    danger: false
                },
                message: {
                    ...state.show,
                    danger: ''
                },
            };
        case HIDE_DEFAULT_SNACKBAR:
            return {
                ...state,
                show: {
                    ...state.show,
                    default: false
                },
                message: {
                    ...state.show,
                    default: ''
                },
            };
        case HIDE_WARNING_SNACKBAR:
            return {
                ...state,
                show: {
                    ...state.show,
                    warning: false
                },
                message: {
                    ...state.show,
                    warning: ''
                },
            };
        default:
            return state;
    }
};